module.exports = __webpack_public_path__ + "img/9-1_07.02516fc7.jpg";